/** Renders a guide step: `{Menu > Item}` as interface chips, `**word**` as bold. */
export function StepText({ text }: { text: string }) {
  return (
    <>
      {text.split(/(\{[^}]+\}|\*\*[^*]+\*\*)/).map((part) => {
        if (part.startsWith('{')) {
          return (
            <span key={part} className="inline-flex flex-wrap items-center gap-1 align-middle">
              {part
                .slice(1, -1)
                .split(' > ')
                .map((item, i) => (
                  <span key={item} className="inline-flex items-center gap-1">
                    {i > 0 && <span className="text-muted-foreground">›</span>}
                    <span className="rounded-md border border-border bg-input/50 px-1.5 py-0.5 text-xs font-medium text-foreground">
                      {item}
                    </span>
                  </span>
                ))}
            </span>
          )
        }
        if (part.startsWith('**')) {
          return (
            <strong key={part} className="font-semibold text-foreground">
              {part.slice(2, -2)}
            </strong>
          )
        }
        return part
      })}
    </>
  )
}
